module.exports = __webpack_public_path__ + "img/undraw_questions-large.9d86851f.webp";